import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { PuntoControlViewModel, PuntoControlItemResultsViewModel, FilterSearchingPuntoControlViewModel, AutoridadControlViewModel } from './puntocontrol.types';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class PuntoControlService extends ResetFiltersService {
    public currentFilterPuntoControl = new FilterSearchingPuntoControlViewModel();

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    getPuntoControlPagedByFilter(params: HttpParams): Observable<PuntoControlItemResultsViewModel> {
        return this.http.get<PuntoControlItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/pagedbyfilter/', { params: params }).pipe();
    }

    getPuntoControl(id: number): Observable<PuntoControlViewModel> {
        return this.http.get<PuntoControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/' + id).pipe();
    }

    createPuntoControl(puntocontrol: PuntoControlViewModel): Observable<any> {
        return this.http.post<PuntoControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol', puntocontrol).pipe();
    }

    editPuntoControl(puntoControl: PuntoControlViewModel): Observable<any> {
        return this.http.put<PuntoControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol', puntoControl).pipe();
    }

    delete(id: number): Observable<any> {
        return this.http.delete<PuntoControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/' + id).pipe();
    }

    export(model: FilterSearchingPuntoControlViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/puntocontrol/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    resetFilter() {
        this.currentFilterPuntoControl = new FilterSearchingPuntoControlViewModel();
    }

    // Autoridades Control

    getAutoridadControl(id: number): Observable<AutoridadControlViewModel> {
        return this.http.get<AutoridadControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/autoridadcontrol/' + id).pipe();
    }

    addAutoridadControl(autoridadControl: AutoridadControlViewModel): Observable<any> {
        return this.http.post<AutoridadControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/autoridadcontrol', autoridadControl).pipe();
    }

    editAutoridadControl(autoridadControl: AutoridadControlViewModel): Observable<any> {
        return this.http.put<AutoridadControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/autoridadcontrol', autoridadControl).pipe();
    }

    deleteAutoridadControl(id: number): Observable<any> {
        return this.http.delete<AutoridadControlViewModel>(this.baseUrl + 'api/mantenimiento/puntocontrol/autoridadcontrol/' + id).pipe();
    }

    getAutoridadesControlByPuntoControl(idPuntoControl: number): Observable<AutoridadControlViewModel[]> {
        return this.http
            .get<AutoridadControlViewModel[]>(this.baseUrl + 'api/mantenimiento/puntocontrol/autoridadcontrolbypuntocontrol/' + idPuntoControl)
            .pipe();
    }
}
